import React from 'react';
import type { CoveragePayloadSchemaMap } from '../../../api/types';

// Provided only on the excess branch. The default empty map makes every
// schema-gated affordance inert on the primary flow (no provider => no schemas).
const SchemaMapContext = React.createContext<CoveragePayloadSchemaMap>({});

interface SchemaMapProviderProps {
  readonly schemas: CoveragePayloadSchemaMap;
  readonly children: React.ReactNode;
}

export function SchemaMapProvider({
  schemas,
  children,
}: SchemaMapProviderProps) {
  return (
    <SchemaMapContext.Provider value={schemas}>
      {children}
    </SchemaMapContext.Provider>
  );
}

export const useSchemaMap = (): CoveragePayloadSchemaMap =>
  React.useContext(SchemaMapContext);
